import React, { Component } from 'react';
import { InteractionManager } from 'react-native';
import { Buffer } from 'buffer';

import { OPComponent } from '..';

import axios from '../../../axios-retried';
import { cacheDir } from './file_cache';
import { getResourceFromObjectType } from '../actions';
import { getPreSignedUrlForDownload } from '../../../services/fileService';

export default class CacheWrapper extends OPComponent {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    // return this.props.cachePath !== nextProps.cachePath;
    // maybe implement this, but for now we are always covered by
    // shouldComponentUpdate in cached_image
    return true;
  }

  cacheFromRemoteURL(cachePath, remoteURL) {
    // console.log('cacheFromRemoteURL: ' + cachePath + ' : ' + remoteURL);

    return axios
      .get(remoteURL, {
        responseType: 'arraybuffer',
      })
      .then((response) => {
        const contentType = response.headers['content-type'];
        const imgType = contentType?.match('image/') ? contentType.split('/')[1] : false;
        const imgTypes = ['png', 'jpeg', 'jpg', 'gif', 'tif', 'tiff', 'bmp'];
        // check that we got a valid image
        if (response.status === 200 && response.data.byteLength > 0) {
          let cachedData = null;
          if (imgType && imgTypes.indexOf(imgType) >= 0) {
            cachedData = `data:${contentType};base64,`;
          } else if (remoteURL.match('.mp4')) {
            cachedData = `data:video/mp4;base64,`;
          }
          cachedData += Buffer.from(response.data, 'binary').toString('base64');
          // also store this base64 data using html5 LocalStorage
          localStorage.setItem(cachePath, JSON.stringify({ uri: cachedData }));
          return cachedData;
        } else {
          console.log(
            'axios got remoteURL with invalid response',
            remoteURL,
            contentType,
            JSON.stringify(response, null, 2)
          );
        }
        return Promise.reject();
      });
  }

  setUri(url) {
    this.props.onUri && this.props.onUri(url);
  }

  downloadError() {
    this.props.onError && this.props.onError();
  }

  _getRemoteUrl(preSignedUrlObj, isThumb) {
    // console.info('----------------- _getRemoteUrl', preSignedUrlObj);
    return getPreSignedUrlForDownload(preSignedUrlObj)
      .then((retVal) => {
        // console.info('_getRemoteUrl returned', isThumb, retVal);
        const { url, thumbnail } = retVal;
        // console.info('_getRemoteUrl returned thumbnail url ' + thumbnail);
        // console.info('_getRemoteUrl returned full url ' + url);

        if (!url && !thumbnail) {
          console.error('getPreSignedUrlForDownload returned invalid URLS', preSignedUrlObj);
          throw new Error();
        }
        return (isThumb && thumbnail) || url || thumbnail;
      })
      .catch((e) => {
        console.info('_getRemoteUrl error', e);
        this.downloadError();
      });
  }

  _downloadResource(preSignedUrlObj, isThumb, cachePath) {
    // console.info('******** _downloadResource', preSignedUrlObj);
    return this._getRemoteUrl(preSignedUrlObj, isThumb).then((remoteUrl) => {
      // console.info('>>>> _downloadResource', remoteUrl)
      this.setUri(remoteUrl);
      const sevenDays = 1000 * 60 * 60 * 24 * 7 - 5000; // in ms, minus 5 seconds so it expires before the actual 7 days
      const resourceMeta = JSON.stringify({ uri: remoteUrl, expiry: Date.now() + sevenDays });
      localStorage.setItem(cachePath, resourceMeta);
    });
  }

  _getImageUrl() {
    const { attachment, isThumb } = this.props;
    const { objectType, objectId, fileName } = attachment;

    const objectTypeSubDir = isThumb ? 'thumbnail' : 'fullsize';
    const cacheFileName = `${objectId}_${objectTypeSubDir}_${fileName}`;
    // console.info('cacheFileName ' + cacheFileName);

    const cachedFileInfo = localStorage.getItem(cacheFileName);
    const isCachedAndNotExpired = cachedFileInfo && JSON.parse(cachedFileInfo).expiry > Date.now();
    if (isCachedAndNotExpired) {
      this.setUri(JSON.parse(cachedFileInfo).uri);
    } else {
      localStorage.removeItem(cacheFileName);
      const resource = getResourceFromObjectType(objectType, false);
      const preSignedUrlObj = { resource, objectId, fileName };
      this._downloadResource(preSignedUrlObj, isThumb, cacheFileName);
    }
  }

  render() {
    // fetch the image each time render is called to deal with short lived remote URI's

    // console.info('render CachedMessageImage', this.props.message)
    InteractionManager.runAfterInteractions(() => {
      this._getImageUrl();
    });

    return this.props.children;
  }
}
